<profile-section class="intro-section">
  <ng-container slot="title" i18n>Résumé </ng-container>

  <p>{{ profile?.resume }}</p>
</profile-section>
